import { Form } from 'react-final-form'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'
import MyDatePicker from '../../../control/datepicker/datepicker'
import Select from '../../../control/select/select'
import useFaculty from '../../../services/um/lookups/useFaculty'
import useProjectStatus from '../../../services/um/lookups/useProjectStatus'
import useStatus from '../../../services/um/lookups/useStatus'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'

import { SearchKeywordType } from '../../../services/um/useSearchFirstTime'
import useProjectType from '../../../services/um/lookups/useProjectType'
import { FormApi } from 'final-form'
import { useState } from 'react'
import moment from 'moment'

interface PanelProps {
    initialValue: SearchKeywordType
    onSearch: (values: SearchKeywordType) => void
    onReset: (form: any) => void
}

const Panel: React.FC<PanelProps> = ({ onSearch, initialValue, onReset }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const { faculty } = useFaculty()
    const { projectStatus } = useProjectStatus()
    const { statusList } = useStatus()
    const { projectT } = useProjectType()
    const [endDate, setEndDate] = useState<string | null>(moment(new Date()).format('YYYY-MM-DD'))
    let defaultProjectType = initialValue.projectType ? [initialValue.projectType] : undefined
    let defaultSubmitted = initialValue.submittedType ? [initialValue.submittedType.toString()] : undefined
    let defaultFaculty = initialValue.facultyID ? [initialValue.facultyID] : undefined

    // const formatedStatusList = statusList.map((itm) => {
    //     return {
    //         label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
    //         value: `${itm.id}`,
    //     }
    // })

    const handleStartDateChange = (form: FormApi<SearchKeywordType>, value: string | null) => {
        if (value && endDate) {
            let isStartAfter = moment(value).isAfter(endDate)
            if (isStartAfter) {
                form.change('endDate', new Date(value))
            }
        }
    }

    const handleEndDateChange = (value: string | null) => {
        setEndDate(value)
    }

    return (
        <Grid className={classes.root}>
            <Form onSubmit={onSearch} initialValues={initialValue}>
                {({ handleSubmit, form, values }) => (
                    <Grid container spacing={2} className={classes.container}>
                        <Grid item xs={12} sm={6}>
                            <MyTextfield
                                name="keyword"
                                materialInputProps={{
                                    label: `${translate.get('UM.FIRST_TIME.KEYWORD.LABEL')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.FIRST_TIME.KEYWORD.PLACEHOLDER')}`,
                                    size: 'small',
                                }}
                                resetButtom
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Select
                                name="submittedType"
                                option={projectStatus}
                                label={`${translate.get('UM.FIRST_TIME.PROJEC_TTYPE.LABEL')}`}
                                placeholder={`${translate.get('UM.FIRST_TIME.PROJEC_TTYPE.PLACEHOLDER')}`}
                                size="small"
                                defaultValue={defaultSubmitted}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Select
                                name="projectType"
                                option={[
                                    {
                                        value: null,
                                        label: translate.get('LABEL.NOT_SPECIFIC'),
                                    },
                                    ...projectT,
                                ]}
                                label={`${translate.get('UM.FIRST_TIME.PROJECT_TYPE.LABEL')}`}
                                placeholder={`${translate.get('UM.FIRST_TIME.PROJECT_TYPE.LABEL')}`}
                                size="small"
                                defaultValue={defaultProjectType}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Select
                                name="facultyID"
                                option={[
                                    {
                                        value: null,
                                        label: translate.get('LABEL.NOT_SPECIFIC'),
                                    },
                                    ,
                                    ...faculty,
                                ]}
                                label={`${translate.get('UM.FIRST_TIME.FACILITY.LABEL')}`}
                                placeholder={`${translate.get('UM.FIRST_TIME.FACILITY.PLACEHOLDER')}`}
                                size="small"
                                defaultValue={defaultFaculty}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <MyDatePicker
                                name="startDate"
                                label={`${translate.get('UM.FIRST_TIME.STARTDATE.LABEL')}`}
                                onChangeValue={(val: string) => handleStartDateChange(form, val)}
                                size={'small'}
                                icon={<CalendarTodayIcon color="disabled" />}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MyDatePicker
                                name="endDate"
                                label={`${translate.get('UM.FIRST_TIME.ENDDATE.LABEL')}`}
                                size={'small'}
                                icon={<CalendarTodayIcon color="disabled" />}
                                minDate={new Date(values.startDate)}
                                onChangeValue={handleEndDateChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify="flex-end" spacing={2}>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="default"
                                        onClick={() => {
                                            onReset(form)
                                        }}
                                    >
                                        {translate.get('BUTTON.RESET')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        {translate.get('BUTTON.SEARCH')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Form>
        </Grid>
    )
}

export default Panel

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    container: {
        padding: '1.7rem',
    },
    reset: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
}))
